import './MobileMenu.scss';
import template from './MobileMenu.vhtml';

export default {
	name: 'MobileMenu',
	template: template,
	props: {
		items: {
			type: String,
			required: true,
		},
		homeUrl: {
			type: String,
			default: '/',
		},
	},
	data: () => ({
		menuItems: [],
	}),
	computed: {},
	methods: {},
	created() {
		this.menuItems = JSON.parse(this.items);
		console.log(this.menuItems);
	},
};
